module.exports = __webpack_public_path__ + "media/src/images/icons/arrow/left-5ce0dc7c6a200876401edc916497ecbd.svg";